import AuthApiEndpoints from './auth.api';
import UserApiEndpoints from './user.api';
import ActivitiesApiEndpoints from './activities.api';
import CountriesApiEndpoints from './countries.api';
import HostApi from './host';
import MapsApiEndpoints from './maps.api';
import ListingsApiEndpoints from './public-listings.api';
import CitiesApiEndpoints from './cities.api';
import BookingApiEndpoints from './booking.api';
import GuestApi from './guest/index';
import CurrenciesApiEndpoints from './currencies.api';
import CardsApiEndpoints from './cards.api';
import ContactUsApiEndpoints from './contact-us.api';
import * as helpers from './helpers';
import PaymentsApiEndpoints from './payments.api';

const Api = {
  ...helpers,
  auth: AuthApiEndpoints,
  user: UserApiEndpoints,
  activities: ActivitiesApiEndpoints,
  countries: CountriesApiEndpoints,
  currencies: CurrenciesApiEndpoints,
  hostApi: HostApi,
  maps: MapsApiEndpoints,
  listings: ListingsApiEndpoints,
  cities: CitiesApiEndpoints,
  booking: BookingApiEndpoints,
  guestApi: GuestApi,
  contactUs: ContactUsApiEndpoints,
  cards: CardsApiEndpoints,
  payments: PaymentsApiEndpoints,
};

export default Api;
